"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created 18.3.2021
 */

var immutable_1 = require("immutable");

var moment = require("moment");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * Mapping of newly created internal site to similar internal site (RFC 385, PROMO-34).
 * @author Radek Beran
 */


var SiteNewToSimilar =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteNewToSimilar, _DomainObject_1$Domai);

  /**
   * @param id the internal id of mapping record
   * @param newSiteId internal id of newly created site
   * @param similarSiteId internal id of similar site
   * @param activationTime time when new site is activated
   * @param exportTimes times when POE learning history for new site was exported (can contain multiple dates
   * because of first export is performed in advance before site activation time and the following short
   * interval up to activation time is exported later); empty list if export was not performed yet
   */
  function SiteNewToSimilar(id, newSiteId, similarSiteId, activationTime, exportTimes) {
    var _this;

    _classCallCheck(this, SiteNewToSimilar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteNewToSimilar).call(this));
    _this.id = id;
    _this.newSiteId = newSiteId;
    _this.similarSiteId = similarSiteId;
    _this.activationTime = activationTime;
    _this.exportTimes = exportTimes;
    return _this;
  }
  /**
   * Returns last (biggest) export time if any.
   */


  _createClass(SiteNewToSimilar, [{
    key: "getLastExportTime",
    value: function getLastExportTime() {
      return this.exportTimes.isEmpty() ? null : moment.max(this.exportTimes.toArray());
    }
  }], [{
    key: "empty",
    value: function empty(newSiteId, similarSiteId, activationTime) {
      return new SiteNewToSimilar(utils_1.Utils.VOID_ID, newSiteId, similarSiteId, activationTime, SiteNewToSimilar.EMPTY_TIMES);
    }
  }]);

  return SiteNewToSimilar;
}(DomainObject_1.DomainObject);

exports.SiteNewToSimilar = SiteNewToSimilar;
SiteNewToSimilar.EMPTY_TIMES = immutable_1.List();
/**
 * data schema
 */

SiteNewToSimilar.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SiteNewToSimilar.name);
  return {
    id: builder.id('id'),
    newSiteId: builder.id('newSiteId'),
    similarSiteId: builder.id('similarSiteId'),
    activationTime: builder.date('activationTime', DateParser_1.DateParser.ISO_PATTERN),
    exportTimes: builder.listOf(builder.date('exportTimes', DateParser_1.DateParser.ISO_PATTERN))
  };
}();